import React, { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import { useMediaQuery } from "react-responsive";
import MDTypography from "components/MDTypography";
import { useNavigate } from "react-router-dom";
import { getDefaultSearchUser, getSearchUser } from "services/apiService";
import { Avatar, Card, IconButton, InputAdornment } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import MDInput from "components/MDInput";
import MDAvatar from "components/MDAvatar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import SpinLoader from "components/SpinLoader";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export default function Search() {
  let navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [defaultUsers, setDefaultUsers] = useState("");

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3,
    },
    laptop: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      slidesToSlide: 2,
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 330 },
      items: 1,
    },
    mobileSmall: {
      breakpoint: { max: 320, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  useEffect(() => {
    fetchDefaultSearchuser();
  }, []);

  const fetchDefaultSearchuser = async () => {
    const searchUserRes = await getDefaultSearchUser();
    // console.log("ser", searchUserRes);
    setDefaultUsers(searchUserRes);
  };

  const handleSearch = async (value) => {
    setSearchTerm(value);

    if (value.length <= 0 || value === "") {
      // console.log("empty");

      setSearchResult([]);
      return;
    }

    // console.log("value", value);
    const searchRes = await getSearchUser(value, 0);
    // console.log("searchRes", searchRes);
    setSearchResult(searchRes);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleEventDetails = (value) => {
    navigate(`/profile/?username=${value}`);
  };

  return (
    <DashboardLayout>
      <MDBox sx={{ height: "100%" }}>
        <MDBox
          sx={{
            display: "flex",
            justifyContent: "space-around",

            alignItems: "center",
            height: "100px",
          }}
        >
          <IconButton sx={{ color: "#ffffff" }} onClick={() => handleBack()}>
            <MDTypography fontSize="30px">
              <ArrowBackIcon />
            </MDTypography>
          </IconButton>
          <MDBox sx={{ width: { xs: "80%", md: "100%" } }}>
            <MDInput
              autoComplete="off"
              fullWidth
              sx={{}}
              placeholder="Search here..."
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton>
                      <SearchIcon sx={{ color: "#fff" }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </MDBox>

          <IconButton sx={{ color: "#ffffff" }} onClick={() => handleBack()}>
            <MDTypography color="button" fontSize="30px">
              <ClearIcon />
            </MDTypography>
          </IconButton>
        </MDBox>
        {searchResult.length <= 1 ? (
          <MDBox
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginBottom: "2rem",
            }}
          >
            {defaultUsers.length > 0 ? (
              <MDBox
                sx={{
                  width: { xs: "75%", md: "70%" },
                  marginTop: "7rem",
                }}
              >
                <MDBox sx={{ textAlign: "center", marginBottom: "1rem" }}>
                  <MDTypography>
                    Follow people to start seeing photos they share
                  </MDTypography>
                </MDBox>
                <Carousel responsive={responsive} infinite={true} autoPlay>
                  {defaultUsers.map((item, idx) => (
                    <Card
                      sx={{
                        backgroundColor: "#2a2929",

                        padding: "1rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "10px",
                        marginLeft: "10px",
                        height: "200px",
                      }}
                      onClick={() => handleEventDetails(item.username)}
                    >
                      <MDAvatar
                        alt="Remy Sharp"
                        src={item.pic}
                        sx={{
                          width: 56,
                          height: 56,
                        }}
                        imgProps={{
                          style: { height: "100%", width: "100%" },
                        }}
                      />
                      <MDTypography
                        sx={{
                          color: "white",
                          fontWeight: "700",
                        }}
                      >
                        {item.username}
                      </MDTypography>
                    </Card>
                  ))}
                </Carousel>
              </MDBox>
            ) : (
              <SpinLoader />
            )}
          </MDBox>
        ) : null}

        <MDBox
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "left",
            marginBottom: "2rem",
            paddingLeft: "2.5rem",
          }}
        >
          <MDBox sx={{ width: { xs: "75%", md: "40%" } }}>
            {searchResult.length !== 0 ? (
              <>
                {searchResult.map((item, idx) => (
                  <MDBox
                    key={idx}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1rem",
                      cursor: "pointer",
                      padding: "0.5rem",

                      "&:hover": {
                        backgroundColor: "#331b03",
                      },
                    }}
                    onClick={() => handleEventDetails(item.username)}
                  >
                    <MDAvatar
                      src={item.pic}
                      imgProps={{ style: { height: "100%", width: "100%" } }}
                    />
                    <MDBox>
                      <MDTypography fontWeight="bold">
                        {item.fullName}
                      </MDTypography>
                      <MDTypography fontSize="15px">
                        {item.username}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                ))}
              </>
            ) : (
              <MDBox
                sx={{
                  height: "500px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              ></MDBox>
            )}
          </MDBox>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}
